export default __webpack_public_path__ + "static/media/scrum-event-sheets-hero.c21c1f45.png";